module.exports = __webpack_public_path__ + "img/shidu.64f4ecc9.png";